export const validateCustomerCodeLocal = (value) => {
  const code = String(value ?? '').trim()
  if (!code) return '顧客コードが未入力です。'
  if (!/^[0-9]+$/.test(code)) {
    return '顧客コードは数字(0-9)のみ入力してください。'
  }
  if (code.length >= 5) {
    return '顧客コードは4桁以内で入力してください。'
  }
  return ''
}

export const validateBranchCodeLocal = (value) => {
  const code = String(value ?? '').trim()
  if (!code) return '' // Không có branch là hợp lệ
  if (!/^[A-Z0-9]+$/i.test(code)) {
    return '枝番は英数字(A-Z,0-9)のみ入力してください'
  }
  if (code.length >= 3) {
    return '枝番は2文字以内で入力してください'
  }
  return ''
}

export const normalizeCustomerCode = (value) => {
  const code = String(value ?? '').trim()
  if (!code) return ''
  if (!/^[0-9]+$/.test(code)) return code
  if (code.length < 4) return code.padStart(4, '0')
  return code
}

export const normalizeBranchCode = (value) => {
  const code = String(value ?? '').trim()
  return code ? code.toUpperCase() : ''
}
